import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useForm } from "react-hook-form";
import Styles from "../demo/demo.module.css";
import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import { ConfirmationDiaolog } from "Util/Toast";
import { Services } from "Services";
Modal.setAppElement("#root"); // required for accessibility

export default function AssignDemoRequestModal({
    isOpen,
    setIsOpen,
    options,
    checkedData,
    setCheckedData,
    setrefetch,
    setSelectedData,
    SelectedData,
}) {
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(null);
    const [error, setError] = useState(null);

    const CallData = () => {
        const token = {
            Authorization: `token ${localStorage.getItem("token")}`,
        };
        let body = { DemoRequests: checkedData, AdminUserID: selected };
        setLoading(true);

        Services.AssignDemoRequest("POST", JSON.stringify(body), token)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setIsOpen(false);
                    setrefetch((prev) => !prev);
                    setCheckedData([]);
                    setSelectedData([]);

                    toast.success(
                        `${"DemoRequests successfully assigned Successfully"}`,
                        {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        }
                    );
                } else if (response.Status === 0) {
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const onSubmit = async () => {
        // onConfirm(data.claimedBy);

        if (selected == null) {
            setError("Please Select SM");
            return;
        }
        const hasInvalidClaim = SelectedData.some(
            (item) => item.ClaimedBy !== 0 && item.ClaimedBy !== -1
        );
        if (hasInvalidClaim) {
            ConfirmationDiaolog(
                "Some of the selected leads are already assigned to a Sales Manager. Do you still want to reassign them?",
                "Assign",
                CallData
            );
        } else {
            CallData();
        }
    };
    console.log(selected);
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            contentLabel="Assign Demo Request"
            style={{ height: "600px" }}
            className={Styles["assignModal"]}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["modal_Container"]}>
                <header>
                    <h3> Lead Assignment</h3>
                </header>
                <div className={Styles["Complaint_Details"]}>
                    <select
                        onChange={(e) => setSelected(e.target.value)}
                        defaultValue={""}
                        style={{
                            height: "3rem",
                            borderRadius: "10px",
                            outline: "none",
                            textIndent: "1rem",
                            border: "1px solid #ccc",
                        }}>
                        <option value="" disabled>
                            Select SM
                        </option>
                        {options.map((item) => (
                            <option value={item.value}>{item.label}</option>
                        ))}
                    </select>
                    {error && (
                        <p style={{ fontSize: "14px", color: "red" }}>
                            {error}
                        </p>
                    )}
                </div>
                {loading ? (
                    <div className={Styles["loader"]}>
                        <ReactLoading
                            color="green"
                            type="spokes"
                            height={30}
                            width={30}
                        />
                    </div>
                ) : (
                    <div
                        className={Styles["control_Buttons"]}
                        style={{ margin: 0 }}>
                        <button
                            className={Styles["resolve"]}
                            onClick={onSubmit}>
                            Assign
                        </button>
                        <button
                            className={Styles["close"]}
                            onClick={() => setIsOpen(false)}>
                            Close
                        </button>
                    </div>
                )}
            </div>
        </Modal>
    );
}
